import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import HeaderImg1 from "../../Assets/HomePage/HeaderImg1.png";
import HeaderImg2 from "../../Assets/HomePage/HeaderImg2.png";
import HeaderImg3 from "../../Assets/HomePage/HeaderImg3.png";
import Form from "./Form";

const Header = () => {
  const slides = [
    {
      image: HeaderImg1,
      title:
        "Your Trusted Partner for ISO Certifications & Business Compliance",
      description:
        "We help businesses of all sizes achieve international standards through ISO certifications, process implementation, and regulatory compliance — quickly, professionally, and affordably.",
    },
    {
      image: HeaderImg2,
      title:
        "Your Trusted Partner for ISO Certifications & Business Compliance",
      description:
        "We help businesses of all sizes achieve international standards through ISO certifications, process implementation, and regulatory compliance — quickly, professionally, and affordably.",
    },
    {
      image: HeaderImg3,
      title:
        "Your Trusted Partner for ISO Certifications & Business Compliance",
      description:
        "We help businesses of all sizes achieve international standards through ISO certifications, process implementation, and regulatory compliance — quickly, professionally, and affordably.",
    },
  ];

  return (
    <div className="w-full relative py-6 bg-gradient-to-br from-[#F7FAFF] to-[#E6F4FF]">
      <div className="px-4 lg:px-12">
        <div className="flex flex-col lg:flex-row gap-4 lg:gap-6">
          {/* Carousel - 70% width on desktop */}
          <div className="w-full lg:w-[70%] relative rounded-xl overflow-hidden shadow-xl h-[350px] sm:h-[400px] md:h-[450px]">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={0}
              slidesPerView={1}
              pagination={{ clickable: true }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              loop={true}
              className="w-full h-full"
              breakpoints={{
                0: {
                  navigation: false,
                },
                768: {
                  navigation: true,
                },
              }}
            >
              {slides.map((slide, index) => (
                <SwiperSlide key={index} className="h-full">
                  <div className="relative w-full h-full">
                    <img
                      src={slide.image}
                      alt={`Slide ${index + 1}`}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black bg-opacity-40"></div>

                    <div className="absolute inset-0 flex items-center text-left px-6 sm:px-8 md:px-12 lg:px-16 text-white">
                      <div className="max-w-2xl space-y-2 sm:space-y-3 md:space-y-4">
                        <h1 className="text-xl sm:text-2xl md:text-3xl font-bold leading-tight">
                          {slide.title}
                        </h1>
                        <p className="text-xs sm:text-sm md:text-base opacity-90 leading-relaxed">
                          {slide.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {/* Form - 30% width on desktop, full width on mobile */}
          <div className="w-full lg:w-[30%] h-[350px] sm:h-[400px] md:h-[450px]">
            <div className="p-[2px] rounded-xl bg-gradient-to-r from-[#0070a8] to-[#023955] shadow-xl">
              <div className="w-full h-full bg-white rounded-xl p-3 sm:p-4 md:p-6">
                <Form />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
